/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskAutomatedDomains
 */
export interface ExecRiskAutomatedDomains {
    /**
     * 
     * @type {Array<string>}
     * @memberof ExecRiskAutomatedDomains
     */
    experian?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExecRiskAutomatedDomains
     */
    zoominfo?: Array<string>;
}

/**
 * Check if a given object implements the ExecRiskAutomatedDomains interface.
 */
export function instanceOfExecRiskAutomatedDomains(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskAutomatedDomainsFromJSON(json: any): ExecRiskAutomatedDomains {
    return ExecRiskAutomatedDomainsFromJSONTyped(json, false);
}

export function ExecRiskAutomatedDomainsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskAutomatedDomains {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'experian': !exists(json, 'experian') ? undefined : json['experian'],
        'zoominfo': !exists(json, 'zoominfo') ? undefined : json['zoominfo'],
    };
}

export function ExecRiskAutomatedDomainsToJSON(value?: ExecRiskAutomatedDomains | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'experian': value.experian,
        'zoominfo': value.zoominfo,
    };
}

